/* eslint-disable */

import request from '@/utils/request'

const MANAGEMENT = `${API_GATEWAY_URL}/managent`
const HOST = `${API_GATEWAY_URL}/host`
const SUMMARY = `${API_GATEWAY_URL}/summary`
const USER = `${API_GATEWAY_URL}/user` // 9090 端口

// 登录
export function accountLogin(data) {
  return request(MANAGEMENT + '/plat/staffs/login', {
    method: 'POST',
    data: {
      ...data,
      projectId: PROJECT_ID,
    },
  })
}

// 获取验证码
export function getVerifyCode(data) {
  return request(MANAGEMENT + '/plat/staffs/sendVerifyCode', {
    method: 'PUT',
    data,
  })
}

// 修改密码
export function resetPassword(data) {
  return request(MANAGEMENT + '/plat/staffs/updatePasswdAfterLogin', {
    method: 'PUT',
    data,
  })
}

// 获取用户信息
export function fetchUserInfo() {
  return request(MANAGEMENT + '/plat/staffs/info')
}

//获取城市信息
export function getCity() {
  return request(USER + '/nb_position/cites/list')
}

//获取省信息
export const getProvinces = () => {
  return request(USER + '/nb_position/provinces')
}
//根据省id获取城市
export function getCityById(id) {
  return request(USER + `/nb_position/cites/${id}`)
}
//根据城市id获取区域
export function getareasById(id) {
  return request(USER + `/nb_position/areas/${id}`)
}
//字典查询
export function getKeyWords(itemKey) {
  return request(USER + `/nb_dictionary/get/${itemKey}`)
}
// ============= 销售人员管理 =============

export function getRobotSalers(params) {
  return request(MANAGEMENT + `/robot_saler/getRobotSalers`, {
    params,
  })
}

export function getRobotSalersByRobotId(id) {
  return request(MANAGEMENT + `/robot_saler/getRobotSalers/robot/${id}`)
}

//获取开发商下机器人信息
export function getRobotsByDeveloperId(id) {
  return request(MANAGEMENT + `/robot/getRobotsByDeveloperId/${id}`)
}

//添加销售人员信息
export function addSaler(data) {
  return request(MANAGEMENT + '/robot_saler/add', {
    method: 'POST',
    data,
  })
}

//批量添加销售人员信息
export function addSalerList(data) {
  return request(MANAGEMENT + `/robot_saler/add/list/${data.robotId}`, {
    method: 'POST',
    data: data.robotSalerVo,
  })
}

//修改销售人员信息
export function updateSaler(data) {
  return request(MANAGEMENT + `/robot_saler/update/${data.id}`, {
    method: 'PUT',
    data: data,
  })
}

//删除销售人员信息
export function removeSaler(id) {
  return request(MANAGEMENT + `/robot_saler/delete/${id}`, {
    method: 'DELETE',
  })
}

// ============= 客户管理 =============

export function getCustomers(params) {
  return request(MANAGEMENT + '/robot_account/getCustomers', { params })
}

export function getCustomerInfo(id) {
  return request(MANAGEMENT + `/robot_account/getCustomerInfoById/${id}`)
}

export function getRobotOrderRecordOfCustomerMobile(customerMobile) {
  return request(MANAGEMENT + '/robot_order_record/getRobotOrderRecordOfCustomerMobile', {
    params: {
      customerMobile,
    },
  })
}

/**
 * 查看客户历史连接记录
 */
export function getRobotConnectRecordsByCustomerMobile(data) {
  return request(MANAGEMENT + '/robot_connect_record/customer/connectRecords', {
    params: data,
  })
}

export function getPointHistory(connectId) {
  return request(MANAGEMENT + `/position_point_record/connectId/${connectId}`)
}

// ============= 机器人管理 =============

export function fetchRobots(params) {
  return request(MANAGEMENT + '/robot/searchRobots', {
    params,
  })
}
//获取机器人NewSeed序列号
export function fetchNewSeedVersion() {
  return request(SUMMARY + '/robot/getRobotVersion')
}
// 销售和机器人解绑
export function unbindRobot(params) {
  return request(MANAGEMENT + '/robot_saler/unbound', {
    method: 'DELETE',
    params,
  })
}

// 根据 id 获取机器人详情
export const fetchRobotDetail = id => {
  return request(MANAGEMENT + `/robot/${id}`)
}

// 根据 开发商 获取机器人设置详情
export const fetchRobotPeriod = developerId => {
  return request(MANAGEMENT + `/robot/getRobotPeriod/${developerId}`)
}

// 设置 机器人设置详情
export const setRobotPeriod = data => {
  return request(MANAGEMENT + '/robot/setRobotPeriod', {
    method: 'POST',
    data,
  })
}

// 根据 开发商 获取机器人不可预约时间段
export const getRobotPeriodNotAllowsByDeveloperId = data => {
  return request(MANAGEMENT + `/robot/getRobotPeriodNotAllowsByDeveloperId/${data.developerId}`, {
    params: {
      type: data.type,
    },
  })
}

//添加机器人不可预约时间段
export const addRobotPeriodNotAllow = data => {
  return request(MANAGEMENT + '/robot/addRobotPeriodNotAllow', {
    method: 'POST',
    data,
  })
}

//修改机器人不可预约时间段
export const updateRobotPeriodNotAllowById = data => {
  return request(MANAGEMENT + `/robot/updateRobotPeriodNotAllowById/${data.id}`, {
    method: 'PUT',
    data,
  })
}

//删除机器人不可预约时间段
export const deleteRobotPeriodNotAllowById = id => {
  return request(MANAGEMENT + `/robot/deleteRobotPeriodNotAllowById/${id}`, {
    method: 'DELETE',
  })
}

//=========================机器人进门配置=========================

//分页查询进门配置列表
export function queryOpenDoorList(params) {
  return request(MANAGEMENT + '/robot/come-in/config', {
    params,
  })
}

//新增进门配置
export const addRobotOpenDoor = data => {
  return request(MANAGEMENT + '/robot/come-in/config', {
    method: 'POST',
    data,
  })
}

//修改进门配置
export function updateRobotOpenDoor(data) {
  return request(MANAGEMENT + `/robot/come-in/config`, {
    method: 'PUT',
    data,
  })
}

//删除进门配置
export const deleteRobotOpenDoor = id => {
  return request(MANAGEMENT + `/robot/come-in/config/${id}`, {
    method: 'DELETE',
  })
}

//添加机器人信息
export const addRobot = data => {
  return request(MANAGEMENT + '/robot/add', {
    method: 'POST',
    data,
  })
}

//修改机器人信息
export function updateRobot(data) {
  return request(MANAGEMENT + `/robot/update/${data.id}`, {
    method: 'PUT',
    data,
  })
}

//删除机器人信息
export const deleteRobot = id => {
  return request(MANAGEMENT + `/robot/delete/${id}`, {
    method: 'DELETE',
  })
}

// 根据开发商ID获取楼盘信息
export const getBuildingByDeveloperId = (id, getAll = false) => {
  return request(MANAGEMENT + `/temi_building/getBuildingsByDeveloperId/${id}`, {
    params: {
      getOn: getAll,
    },
  })
}

// 根据开发商ID获取楼盘信息
export const getH5BuildingByDeveloperId = id => {
  return request(MANAGEMENT + `/temi_building/getBuildingsByDeveloperId/${id}`)
}

// 根据开发商ID获取楼盘更多信息
export const getBuildingMoreById = id => {
  return request(MANAGEMENT + `/temi_building/getBuilding/more/${id}`)
}

// 根据楼盘ID获取房间信息
export const getRoomByBuildingId = id => {
  return request(MANAGEMENT + `/room/getRoomsByBuildingId/${id}`)
}

//删除房间信息 (待替换接口)
export const delRoom = id => {
  return request(MANAGEMENT + `/room/delete/${id}`)
}

//删除房间下机器人绑定关系
export const delRobotInRoom = () => {
  return request(MANAGEMENT + '/room/delete/robot', {
    method: 'DELETE',
  })
}
//添加房间下机器人绑定关系
export const bindRobotInRoom = data => {
  return request(MANAGEMENT + `/room/add/robot/${data.roomId}`, {
    method: 'PUT',
    data,
  })
}
// 设置推荐楼盘
export const setRecommend = data => {
  return request(
    MANAGEMENT + `/temi_building/setRecommend/${data.id}?developerId=${data.developerId}`,
    {
      method: 'PUT',
      data,
    },
  )
}

// 设置楼盘上下架
export const onOff = data => {
  return request(MANAGEMENT + `/temi_building/onOff/${data.id}?onOff=${data.onOff}`, {
    method: 'PUT',
    data,
  })
}

// 设置房间上下架
export const roomOnOff = data => {
  return request(MANAGEMENT + `/room/onOff/${data.id}?onOff=${data.onOff}`, {
    method: 'PUT',
    data,
  })
}

// 获取完整的点位信息
export const fetchPoints = roomId => {
  return request(MANAGEMENT + `/room_position/getFullRoomPositions/${roomId}`)
}

// 保存点位排序信息
export const saveRoomPositionPointSequence = data => {
  return request(MANAGEMENT + '/room_position/saveRoomPositionPointSequence', {
    method: 'PUT',
    data,
  })
}

// 获取点位素材
export const getPointMaterials = params => {
  return request(MANAGEMENT + '/point_material/getPointMaterialsByPointId', {
    method: 'GET',
    params,
  })
}

// 添加点位素材
export const addPointMaterial = data => {
  return request(MANAGEMENT + '/point_material/add', {
    method: 'POST',
    data,
  })
}

//修改点位素材
export const updatePointMaterial = data => {
  return request(MANAGEMENT + `/point_material/update/${data.id}`, {
    method: 'PUT',
    data,
  })
}

// 删除点位素材
export const deletePointMaterial = id => {
  return request(MANAGEMENT + `/point_material/delete/${id}`, {
    method: 'DELETE',
  })
}

// 获取导览素材
export const getGuideList = roomId => {
  return request(MANAGEMENT + `/robot_guide/list/${roomId}`, {
    method: 'GET',
  })
}

// 添加导览素材
export const addGuide = data => {
  return request(MANAGEMENT + '/robot_guide/add', {
    method: 'PUT',
    data,
  })
}

// 修改导览素材
export const updateGuide = data => {
  return request(MANAGEMENT + '/robot_guide/update', {
    method: 'PUT',
    data,
  })
}

// 删除导览路线
export const removeGuide = id => {
  return request(MANAGEMENT + `/robot_guide/del?id=${id}`, {
    method: 'DELETE',
  })
}

// 删除导览背景音乐
export const deleteBackgroundMusicById = id => {
  return request(MANAGEMENT + `/robot_guide/deleteBackgroundMusicById/${id}`, {
    method: 'DELETE',
  })
}

// 根据导览ID获取本地导览所有点位和素材
export const getGuidePointListById = id => {
  return request(SUMMARY + `/guide/get/${id}`, {
    method: 'GET',
  })
}

// 获取导览点位素材
export const getGuidePointList = id => {
  return request(MANAGEMENT + `/robot_guide/get/${id}`, {
    method: 'GET',
  })
}

export const UPLOAD_SERVICE_URL = MANAGEMENT + '/plat/files/upload'
// 文件上传
export function upload(data) {
  return request(MANAGEMENT + '/plat/files/upload', {
    method: 'POST',
    data,
  })
}

// ============= 楼盘管理 =============

//根据楼盘id获取房间列表
export const getRoomsByBuildingId = id => {
  return request(MANAGEMENT + `/room/getRoomsByBuildingId/${id}`)
}

export const getCameraByBuildingId = id => {
  return request(MANAGEMENT + `/temi_building/get/room/list/${id}`)
}

//根据楼盘id获取无人机视频列表
export const getDroneByBuildingId = id => {
  return request(MANAGEMENT + `/uav/get/list/${id}`)
}

//根据roomid获取房间详情
export const getRoom = id => {
  return request(MANAGEMENT + `/room/get/${id}`)
}

//根据roomid获取机器人列表
export const getRobotsByRoomId = id => {
  return request(MANAGEMENT + `/robot/getRobotsByRoomId/${id}`)
}

//根据机器人序列号获取机器人点位信息
export const getRobotsBySerial = serial => {
  return request(MANAGEMENT + `/robot/getRobot/serial/${serial}`)
}

//批量保存点位
export const savehouseTypePosition = data => {
  return request(MANAGEMENT + '/room/save/houseTypePosition', {
    method: 'PUT',
    data,
  })
}

// 新建楼盘
export const createBuilding = data => {
  return request(MANAGEMENT + '/temi_building/save', {
    method: 'PUT',
    data,
  })
}

// 获取楼盘详情
export const fetchBuildingById = id => {
  return request(MANAGEMENT + `/temi_building/getBuilding/${id}`)
}

// 更新楼盘
export const updateBuilding = data => {
  return request(MANAGEMENT + '/temi_building/update', {
    method: 'PUT',
    data,
  })
}

// 新建编辑更多
export const createBuildingMore = data => {
  return request(MANAGEMENT + '/temi_building/add/buildingmore', {
    method: 'POST',
    data,
  })
}

// 更新编辑更多
export const updateBuildingMore = data => {
  return request(MANAGEMENT + '/temi_building/update/buildingmore', {
    method: 'PUT',
    data,
  })
}

// 新建房间
export const createRoom = data => {
  return request(MANAGEMENT + '/room/save', {
    method: 'PUT',
    data,
  })
}

// 更新房间
export const updateRoom = data => {
  return request(MANAGEMENT + '/room/update', {
    method: 'PUT',
    data,
  })
}

// 新建摄像头
export const createCamera = data => {
  return request(MANAGEMENT + '/temi_building/save/camera', {
    method: 'PUT',
    data,
  })
}

// 更新摄像头
export const updateCamera = data => {
  return request(MANAGEMENT + '/temi_building/update/camera', {
    method: 'PUT',
    data,
  })
}

//删除摄像头
export const removeCamera = id => {
  return request(MANAGEMENT + `/temi_building/delete/camera/${id}`, {
    method: 'DELETE',
  })
}

// 新建无人机视频
export const createDrone = data => {
  return request(MANAGEMENT + '/uav/add', {
    method: 'POST',
    data,
  })
}

// 更新无人机视频
export const updateDrone = data => {
  return request(MANAGEMENT + '/uav/update', {
    method: 'PUT',
    data,
  })
}

//删除无人机
export const removeDrone = id => {
  return request(MANAGEMENT + `/uav/delete/${id}`, {
    method: 'DELETE',
  })
}

// 新建开发商
export const createDeveloper = data => {
  return request(MANAGEMENT + '/developer/save', {
    method: 'PUT',
    data,
  })
}

//根据主机ID查询设备
export const getTotalInfoByHostid = id => {
  return request(HOST + `/host_config/get/${id}`, {
    method: 'GET',
    id,
  })
}

//根据主机ID查询场景
export const getAllTemiPatternByHostId = id => {
  return request(MANAGEMENT + `/pattern/getAllTemiPatternByHostId/${id}`, {
    method: 'GET',
    id,
  })
}

//添加场景
export const addPattern = data => {
  return request(MANAGEMENT + '/pattern/add', {
    method: 'POST',
    data,
  })
}

//修改场景
export const updatePattern = data => {
  return request(MANAGEMENT + `/pattern/update/${data.id}`, {
    method: 'PUT',
    data,
  })
}

//删除场景
export const removePattern = id => {
  return request(MANAGEMENT + `/pattern/delete/${id}`, {
    method: 'DELETE',
  })
}

//添加一级点位接口
export const createPrimaryPoint = data => {
  return request(MANAGEMENT + '/room_position/add', {
    method: 'POST',
    data,
  })
}

//添加二级点位接口
export const createSecondaryPoint = data => {
  return request(MANAGEMENT + '/room_position/addPoint', {
    method: 'POST',
    data,
  })
}

//修改一级点位接口
export const updatePrimaryPoint = data => {
  return request(MANAGEMENT + '/room_position/update', {
    method: 'PUT',
    data,
  })
}

//修改二级点位接口
export const updateSecondaryPoint = data => {
  return request(MANAGEMENT + '/room_position/updatePoint', {
    method: 'PUT',
    data,
  })
}

//删除一级点位接口
export const delPrimaryPoint = id => {
  return request(MANAGEMENT + `/room_position/del/${id}`, {
    method: 'DELETE',
  })
}

//删除二级点位接口
export const delSecondaryPoint = id => {
  return request(MANAGEMENT + `/room_position/delPoint/${id}`, {
    method: 'DELETE',
  })
}

//获取某个开发下的所有销售
export function getAllRobotSalers(parmas) {
  return request(MANAGEMENT + '/robot_saler/getAllRobotSalers', {
    parmas,
  })
}

// ============= 营销管理-数据统计 =============

/**
 * 获取某日看房总次数，如果不传则查看总数
 * @param {*} date  YYYY-MM-DD
 */
export const getTotalViewCount = date => {
  return request(MANAGEMENT + '/robot_connect_record/getTotalKanFangNum', {
    method: 'PUT',
    params: {
      date,
    },
  })
}

/**
 * 获取某一周的看房量
 * @param {*} weekInterval - 0 表示当前周， 1，表示上一周 ; 2 表示 上上周
 */
export const getTotalViewCountOfWeek = weekInterval => {
  return request(MANAGEMENT + '/robot_connect_record/getTotalKanFangNumOfWeek', {
    method: 'PUT',
    params: {
      weekInterval,
    },
  })
}

/**
 * 获取当天的 (意向客户： 连3次以上 ) (2次，二次看房）
 *
 * @param {*} date
 * @param {*} times
 */
export const getWillingCustomersByTimes = (date, times) => {
  return request(MANAGEMENT + '/robot_connect_record/getWillingCustomersByTimes', {
    method: 'PUT',
    params: {
      date,
      times,
    },
  })
}

/**
 * 获取某周的 (意向客户： 连3次以上 ) (2次，二次看房）
 * @param {*} weekInterval
 * @param {*} times
 */
export const getWillingCustomersOfWeekByTimes = (weekInterval, times) => {
  return request(MANAGEMENT + '/robot_connect_record/getWillingCustomersOfWeekByTimes', {
    method: 'PUT',
    params: {
      weekInterval,
      times,
    },
  })
}

/**
 * 查出某月各楼盘的看房量
 * @param {*} month
 */
export const getKanFangNumByBuildingOfMonth = month => {
  return request(MANAGEMENT + '/robot_connect_record/getKanFangNumByBuildingOfMonth', {
    method: 'PUT',
    params: {
      month,
    },
  })
}

/**
 * 查出某月每天的看房量
 * @param {*} month
 */
export const getKanFangNumByDayOfMonth = month => {
  return request(MANAGEMENT + '/robot_connect_record/getKanFangNumByDayOfMonth', {
    method: 'PUT',
    params: {
      month,
    },
  })
}

/**
 * 获取热门房间
 */
export const getKanFangNumByBuildingRoom = () => {
  return request(MANAGEMENT + '/robot_connect_record/getKanFangNumByBuildingRoom', {
    method: 'PUT',
  })
}

/**
 * 获取某天的新增客户
 */
export const getNewCustomerNumOfDate = date => {
  return request(MANAGEMENT + '/robot_account/getNewCustomerNumOfDate', {
    method: 'GET',
    params: {
      date,
    },
  })
}

/**
 * 获取各销售的看房量
 */
export const getKanFangNumGroupBySaler = () => {
  return request(MANAGEMENT + '/robot_connect_record/getKanFangNumGroupBySaler', {
    method: 'PUT',
  })
}

// ============= 开发商管理 =============

//获取开发商信息
export function getAllDeveloper() {
  return request(MANAGEMENT + '/developer/getAllDeveloper')
}

//删除开发商信息
export function removeDeveloper(id) {
  return request(MANAGEMENT + `/developer/delete/${id}`, {
    method: 'DELETE',
  })
}

//更新开发商信息
export const updateDeveloper = data => {
  return request(MANAGEMENT + '/developer/update', {
    method: 'PUT',
    data,
  })
}

// ============= 账号管理 =============

// 获取权限配置
export function getPermissionConfig() {
  return request(MANAGEMENT + `/plat/roles/blankPermissions`, {
    params: {
      projectId: PROJECT_ID,
    },
  })
}

// 添加用户
export function addUser(data) {
  return request(MANAGEMENT + '/plat/staffs', {
    method: 'POST',
    data,
  })
}

// 修改用户
export function updateUserInfo(id, data) {
  return request(MANAGEMENT + `/plat/staffs/${id}`, {
    method: 'PUT',
    data,
  })
}

// 获取用户列表
export function queryUserList(params) {
  return request(MANAGEMENT + '/plat/staffs', {
    params: {
      ...params,
    },
    getResponse: true, // 分页信息中，总条数在 Header 中，需要获取原始的 response
  })
}

// 批量删除用户
export function removeUser(ids) {
  return request(MANAGEMENT + '/plat/staffs', {
    method: 'DELETE',
    data: {
      ids,
    },
  })
}

// 获取角色的权限配置
export function getRolePermission(id) {
  return request(MANAGEMENT + `/plat/roles/${id}`)
}

// 查询角色列表
export function queryRoles(params) {
  return request(MANAGEMENT + `/plat/roles/get/${PROJECT_ID}`, {
    params: params,
  })
}

// 删除角色
export function removeRole(id) {
  return request(MANAGEMENT + `/plat/roles/${id}`, {
    method: 'DELETE',
  })
}

// 添加角色
export function addRole(data) {
  return request(MANAGEMENT + '/plat/roles', {
    method: 'POST',
    data,
  })
}

// 修改角色
export function updateRole(id, data) {
  return request(MANAGEMENT + `/plat/roles/${id}`, {
    method: 'PUT',
    data,
  })
}

// 根据用户id 获取权限列表
export function getPermissionsByStaffId() {
  return request(MANAGEMENT + '/plat/staffs/getPermissionsByStaffId', {
    params: {
      projectId: PROJECT_ID,
    },
  })
}
// 根据用户id 获取权限列表
export function getRobotVideoFlowByDayOfMonth(params) {
  return request(MANAGEMENT + '/robot_connect_record/getRobotVideoFlowByDayOfMonth', {
    params,
  })
}

// 根据开发商ID 获取区域权限列表
export const getRegionsByDeveloperId = id => {
  return request(MANAGEMENT + `/plat/roles/getRegionsByDeveloperId/${id}`)
}

// 根据角色ID 获取区域权限列表
export const getRoleRegionsByRoleId = id => {
  return request(MANAGEMENT + `/plat/roles/getRoleRegionsByRoleId/${id}`)
}

// 生成H5链接
export const getLinkGeneration = date => {
  return request(
    SUMMARY +
      `/video/linkGeneration?developerId=${date.developerId}&buildingIds=${date.buildingIds}&ifLogin=${date.ifLogin}`,
    {
      method: 'GET',
    },
  )
}

// 查询首页配置
export const getPanelConfig = serial => {
  return request(MANAGEMENT + `/robot/panel/config?serial=${serial}`)
}

// 添加首页配置
export const addPanelConfig = data => {
  return request(MANAGEMENT + '/robot/panel/config', {
    method: 'POST',
    data,
  })
}

// 修改首页配置
export const updatePanelConfig = data => {
  return request(MANAGEMENT + '/robot/panel/config', {
    method: 'PUT',
    data,
  })
}

// 生成H5链接
export const getTemplateList = () => {
  return request(SUMMARY + `/robot/panel/config/templateList`, {
    method: 'GET',
  })
}

// 生成H5链接
export const getAwakeningList = () => {
  return request(SUMMARY + `/robot/panel/config/awakeningList`, {
    method: 'GET',
  })
}

// 生成H5链接
export const getCardList = () => {
  return request(SUMMARY + `/robot/panel/config/cardList`, {
    method: 'GET',
  })
}

// 获取机器人打招呼内容
export const getTemiGreet = serial => {
  return request(MANAGEMENT + `/temi_greet/get?temiId=${serial}`, {
    method: 'GET',
  })
}

// 添加机器人打招呼内容
export const addTemiGreet = data => {
  return request(MANAGEMENT + '/temi_greet/add', {
    method: 'POST',
    data,
  })
}

// 更新机器人打招呼内容
export const updateTemiGreet = data => {
  return request(MANAGEMENT + '/temi_greet/update', {
    method: 'POST',
    data,
  })
}

// 删除机器人打招呼内容
export const deleteTemiGreetConfig = id => {
  return request(MANAGEMENT + `/temi_greet/del/${id}`, {
    method: 'DELETE',
  })
}

// 获取机器人打招呼距离
export const getDistance = () => {
  return request(MANAGEMENT + `/temi_greet/getDistance`, {
    method: 'GET',
  })
}

// 获取机器人打招呼等待时间
export const getAwaitTime = () => {
  return request(MANAGEMENT + `/temi_greet/getAwaitTime`, {
    method: 'GET',
  })
}

//获取开发商下未绑定的机器人
export const getUnbindRobotList = () => {
  return request(SUMMARY + `/robot/getUnboundRobotByEnterprise`, {
    method: 'GET',
  })
}

export const postGuideTimers = data => {
  return request(MANAGEMENT + '/robot_guide/save/guide/task', {
    method: 'POST',
    data,
  })
}
